import script from "./workload-view-performance-build-helpers-distribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-performance-build-helpers-distribution.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__